// import Slick from "slick-carousel";
import 'slick-carousel';

/**
 * コモンクラス
 * @constructor
 */
class SlickSlider {
  constructor() {

  }
  /**
   * コモン
   */
  init() {
    window.addEventListener('load', () => {
      $('#j-packegingSlider').slick({
        dots: false,
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              centerMode: true,
              slidesToShow: 1
            }
          }
        ],
      });

      
      let modalNum
      $('.j-modalBtn').on('click', (e) => {
        modalNum = $(e.currentTarget).attr('data-modal');
        $('.m-modal__bg').show();
        $('.m-modal__inner').css('display', 'flex');
        $(modalNum).css('display', 'flex');
      });
      $('.m-modal__contents--close').on('click', (e) => {
        $('.m-modal__bg').hide();
        $('.m-modal__inner').hide();
        $('.m-modal__contentsBlock').hide();
        $(modalNum).hide();
      });
    });
    
    // $('#j-productSlider').slick({
    //   dots: true,
    //   infinite: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   swipe: false
    // });

    // $('#j-productSlider2').slick({
    //   dots: true,
    //   infinite: false,
    //   slidesToShow: 1,
    //   slidesToScroll: 1,
    //   swipe: false
    // });
  }

}

export default SlickSlider;
